import {getGeometry, diameter, centroid} from "effects/midi/mappable/lang/geometry.js";

export const diff = () => {
    let lastCentroid = undefined;
    return (...args) => {
        let coords = args[0];
        let _coords = Object.keys(coords).map(
            id => coords[id])
            .filter(x=>x);
        if (_coords.length === 0) {
            return lastCentroid || 0;
        }
        let {x,y} = getGeometry(_coords);
        if (lastCentroid) {
            let dist = Math.sqrt(Math.pow(x - lastCentroid.x, 2) +
                                 Math.pow(y - lastCentroid.y, 2));
            
            lastCentroid = {x,y};
            return dist;
        }
        lastCentroid = {x,y};
        return 0;
    };
};
